import * as React from 'react';

import { Typography2, useTheme } from '@coursera/cds-core';

// TODO: Get rid of dependency on teach-course.
import ToggleSwitch from 'bundles/teach-course/components/ToggleSwitch';

import _t from 'i18n!nls/general-video-player';

import 'css!./__styles__/AutoplayChangeSection';

type Props = {
  isAutoPlayEnabled: boolean;
  onAutoPlayChange?: (isAutoPlayEnabled: boolean) => void;
};

const ToggleLabel = ({ labelText }: { labelText: string | JSX.Element }) => (
  <Typography2 color="invertBody" variant="bodySecondary" component="div">
    {labelText}
  </Typography2>
);

const selectedLabel = (labelText: string) => <strong>{labelText}</strong>;

const AutoplayChangeSection = ({ isAutoPlayEnabled, onAutoPlayChange }: Props) => {
  const theme = useTheme();

  const translatedStrings = {
    on: _t('On'),
    off: _t('Off'),
  };

  const labelForOn = isAutoPlayEnabled ? selectedLabel(translatedStrings.on) : translatedStrings.on;
  const labelForOff = isAutoPlayEnabled ? translatedStrings.off : selectedLabel(translatedStrings.off);

  return (
    <div className="rc-AutoplayChangeSection">
      <Typography2
        variant="subtitleMedium"
        component="div"
        className="autoplay-adjust-header horizontal-box align-items-absolute-center"
        color="invertBody"
      >
        {_t('Autoplay')}
      </Typography2>
      <div className="video-setting-separator" />
      <div className="autoplay-adjust-controls horizontal-box align-items-spacearound">
        <ToggleLabel labelText={labelForOff} />
        <ToggleSwitch
          ariaLabel={isAutoPlayEnabled ? _t('disable autoplay') : _t('enable autoplay')}
          onToggle={(toggleStatus) => {
            if (toggleStatus === ToggleSwitch.getStatus().On) {
              onAutoPlayChange?.(true);
            } else {
              onAutoPlayChange?.(false);
            }
          }}
          defaultStatus={isAutoPlayEnabled ? ToggleSwitch.getStatus().On : ToggleSwitch.getStatus().Off}
          onColor="var(--cds-color-white-0)"
          offColor="var(--cds-color-white-0)"
          toggleHandleColor="var(--cds-color-blue-700)"
          hideStatusText
        />
        <ToggleLabel labelText={labelForOn} />
      </div>
    </div>
  );
};

export default AutoplayChangeSection;
